import { useQuery } from '@tanstack/react-query';

import { usePasswordProtectedQueries } from '@app-velocity/modules/password-sharing';

export const useGetSharedPrototypeFullSummaryQuery = (shareToken?: string) => {
  const { getSharedPrototypeFullSummary } = usePasswordProtectedQueries();

  return useQuery({
    enabled: !!shareToken,
    queryKey: ['scenario-shared-summary', shareToken],
    queryFn: async () => {
      if (!shareToken) return null;

      return await getSharedPrototypeFullSummary(shareToken);
    },
    staleTime: 30000
  });
};
